(function($) {

    const $paralaxImages = $('[data-paralax-speed]');

    $(window).on('scroll', function shiftParalaxOnScroll() {

        $paralaxImages.each(function (index, item) {

            const parentElSelector = item.getAttribute('data-paralax-parent-selector');
            let parentEl = item.parentElement;

            if(parentElSelector){

                let selectedParent = $(item).closest(parentElSelector).get(0);

                if(selectedParent instanceof HTMLElement){
                    parentEl = selectedParent;
                }
            }

            const parentClientRect = parentEl.getBoundingClientRect();
            const offset = parentClientRect.top;
            let multiplier = parseFloat(item.getAttribute('data-paralax-speed'));
            multiplier = multiplier ? multiplier : 0.2;
            if (multiplier > 1) {
                multiplier = multiplier / 100; // means percentage
            }

            const shift =  offset * multiplier;

            item.style.transform = `translateY(${shift}px)`;

        });
    }).trigger('scroll');

})(jQuery);